<div class="copy-settings-container no-select">
  <div class="widget-div">

    <app-shared-widget-container-component class="expanded wide">
      <div title class="widget-div-heading">
        <app-display-icon
          [icon]="icons.contentCopy"
          [colour]="iconColours.secondary">
        </app-display-icon>
        <div>Copy between stores</div>
        <app-display-icon
          [tooltip]="'Copy price banding and saved filters from one store to another. Price banding on the target is replaced; filters are copied into the matching category.'"
          [icon]="icons.infoSlabCircleOutline"
          [colour]="iconColours.secondary">
        </app-display-icon>
      </div>

      <div block>
        <div class="form">
          <div class="form-column full-width">

            <div class="form-control-div">
              <label>Copy from</label>
              <app-shared-custom-select
                [placeholder]="'Select source store…'"
                [allowMultiple]="false"
                [allowSelectAll]="false"
                [maxSelections]="1"
                [showSearchBar]="true"
                [showActionButtons]="false"
                [showChips]="false"
                [showCheckbox]="false"
                [autoSubmitOnSelect]="true"
                [closeOnAutoSubmit]="true"
                [setOptions]="sourceStoreOptions()"
                (selectionChange)="onSourceStoreChange($event)">
              </app-shared-custom-select>
            </div>

            <div class="form-control-div">
              <label>Settings to copy</label>
              <app-shared-custom-select
                [placeholder]="'Select settings'"
                [allowMultiple]="true"
                [allowSelectAll]="true"
                [showSearchBar]="false"
                [showActionButtons]="true"
                [showChips]="false"
                [autoSubmitOnSelect]="true"
                [floatDropdown]="true"
                [setOptions]="settingOptions()"
                (selectionChange)="onSettingsChange($event)">
              </app-shared-custom-select>
              @if (isPriceBandingSelected() && sourceStoreId()) {
                @if (isLoading()) {
                  <p class="copy-settings-hint">Loading price banding rules…</p>
                } @else if (!isSourcePriceBandingLoaded()) {
                  <p class="copy-settings-hint">
                    Price banding rules for <strong>{{ sourceStoreName() }}</strong> will be read when you copy.
                  </p>
                } @else if (sourcePriceBandCount() > 0) {
                  <p class="copy-settings-hint">
                    {{ sourcePriceBandCount() }} price banding
                    {{ sourcePriceBandCount() === 1 ? 'rule' : 'rules' }}
                    will be copied from <strong>{{ sourceStoreName() }}</strong>.
                  </p>
                } @else {
                  <p class="copy-settings-warning">
                    <strong>{{ sourceStoreName() }}</strong> has no price banding rules. Copying will clear the
                    rules on the target store.
                  </p>
                }
              }
              @if (isGeneralFiltersSelected() && sourceStoreId()) {
                <div class="form-control-div nested-filter-picker">
                  <label>General filters to copy</label>
                  @if (isLoadingSourceFilters()) {
                    <p class="copy-settings-hint">Loading general filters…</p>
                  } @else if (hasGeneralFilters()) {
                    <app-shared-custom-select
                      [placeholder]="'Select general filters'"
                      [allowMultiple]="true"
                      [allowSelectAll]="true"
                      [showSearchBar]="false"
                      [showActionButtons]="true"
                      [showChips]="false"
                      [autoSubmitOnSelect]="true"
                      [floatDropdown]="true"
                      [setOptions]="generalFilterOptions()"
                      (selectionChange)="onGeneralFiltersSelectionChange($event)">
                    </app-shared-custom-select>
                  } @else {
                    <p class="copy-settings-hint">
                      No saved general filters on <strong>{{ sourceStoreName() }}</strong>.
                    </p>
                  }
                </div>
              }
              @if (isStockTakeFiltersSelected() && sourceStoreId()) {
                <div class="form-control-div nested-filter-picker">
                  <label>Stock take filters to copy</label>
                  @if (isLoadingSourceFilters()) {
                    <p class="copy-settings-hint">Loading stock take filters…</p>
                  } @else if (hasStockTakeFilters()) {
                    <app-shared-custom-select
                      [placeholder]="'Select stock take filters'"
                      [allowMultiple]="true"
                      [allowSelectAll]="true"
                      [showSearchBar]="false"
                      [showActionButtons]="true"
                      [showChips]="false"
                      [autoSubmitOnSelect]="true"
                      [floatDropdown]="true"
                      [setOptions]="stockTakeFilterOptions()"
                      (selectionChange)="onStockTakeFiltersSelectionChange($event)">
                    </app-shared-custom-select>
                  } @else {
                    <p class="copy-settings-hint">
                      No saved stock take filters on <strong>{{ sourceStoreName() }}</strong>.
                    </p>
                  }
                </div>
              }
            </div>

            <div class="form-control-div">
              <label>Copy to</label>
              @if (hasTargetStores()) {
                <app-shared-custom-select
                  [placeholder]="'Select target store…'"
                  [allowMultiple]="false"
                  [allowSelectAll]="false"
                  [maxSelections]="1"
                  [showSearchBar]="true"
                  [showActionButtons]="false"
                  [showChips]="false"
                  [showCheckbox]="false"
                  [autoSubmitOnSelect]="true"
                  [closeOnAutoSubmit]="true"
                  [setOptions]="targetStoreOptions()"
                  (selectionChange)="onTargetStoreChange($event)">
                </app-shared-custom-select>
              } @else {
                <p class="copy-settings-warning">
                  You do not administer any other store, so there is nowhere to copy these settings to.
                </p>
              }
            </div>

          </div>
        </div>
      </div>

      <div actions class="widget-actions">
        <button
          type="button"
          class="action-button"
          [disabled]="!canCopy()"
          (click)="onCopyClick()">
          @if (isCopying()) {
            <span class="copy-settings-spinner" aria-hidden="true"></span>
            Copying settings…
          } @else {
            <app-display-icon
              [colour]="iconColours.secondary"
              [tooltip]="'Copy the selected settings to the target store'"
              [icon]="icons.contentCopy">
            </app-display-icon>
            Copy
          }
        </button>
      </div>
    </app-shared-widget-container-component>

  </div>
</div>
